import React, { useEffect } from 'react';

const STORAGE_KEY = 'rtc-lang';

export const Config = {
  default: '',
  list: {},
};

const readStoredLanguage = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    return null;
  }
};

const writeStoredLanguage = (language) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, language);
  } catch (error) {
    // Ignore storage failures and fall back to in-memory config.
  }
};

const getActiveLanguage = () => {
  const storedLanguage = readStoredLanguage();
  if (storedLanguage && Config.list[storedLanguage]) {
    return storedLanguage;
  }

  if (Config.default && Config.list[Config.default]) {
    return Config.default;
  }

  return Object.keys(Config.list)[0] || '';
};

const getLanguageFile = () => {
  const activeLanguage = getActiveLanguage();
  const languageConfig = activeLanguage ? Config.list[activeLanguage] : null;
  const file = languageConfig?.file;

  return file?.default || file || {};
};

export const T = (text) => {
  const languageFile = getLanguageFile();
  return [languageFile[text] || text];
};

export const TF = (text, ...args) => {
  const translatedText = T(text)[0];
  return translatedText.replace(/{(\d+)}/g, (match, number) => (
    typeof args[0]?.[number] !== 'undefined' ? args[0][number] : match
  ));
};

export const Translator = ({ children }) => <>{children}</>;

export const LanguageList = ({ Language }) => {
  useEffect(() => {
    if (Language) {
      writeStoredLanguage(Language);
    }
  }, [Language]);

  return null;
};
